/**
 * Countdown end date sources (priority):
 * - Theme editor: .countdown-sync text (morphdom updates text on change)
 * - Live store: script.noju-countdown-data JSON from Liquid (saved theme)
 */
(function () {
  var SELECTOR = '[data-noju-countdown]';
  var WRAP = '.product__block__countdown';
  var SYNC = '.countdown-sync';
  var DATA = 'script.noju-countdown-data';
  var timers = new Map();
  var observeTimer = null;

  function isEditor() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function readDateFromJson(wrap) {
    var el = wrap && wrap.querySelector(DATA);
    if (!el || !el.textContent) return '';
    try {
      var parsed = JSON.parse(el.textContent);
      if (parsed && parsed.endDate) return String(parsed.endDate).trim();
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function readDateFromSync(wrap) {
    var syncs = wrap.querySelectorAll(SYNC);
    var i = syncs.length - 1;
    for (; i >= 0; i--) {
      var text = (syncs[i].textContent || '').trim();
      if (text) return text;
    }
    return '';
  }

  function getSettingDate(wrap) {
    if (!wrap) return '';

    var fromSync = readDateFromSync(wrap);
    var fromJson = readDateFromJson(wrap);
    var fromWrap = (wrap.getAttribute('data-countdown-setting-date') || '').trim();

    if (isEditor()) {
      if (fromSync) return fromSync;
      if (fromJson) return fromJson;
      return fromWrap;
    }

    if (fromJson) return fromJson;
    if (fromSync) return fromSync;
    return fromWrap;
  }

  function applyDateToWrap(wrap, date) {
    if (!wrap || !date) return;

    var sync = wrap.querySelector(SYNC);
    var curWrap = (wrap.getAttribute('data-countdown-setting-date') || '').trim();
    var curText = sync ? (sync.textContent || '').trim() : '';
    if (curWrap === date && curText === date) return;

    wrap.setAttribute('data-countdown-setting-date', date);
    if (sync) sync.textContent = date;

    var dataEl = wrap.querySelector(DATA);
    if (dataEl) dataEl.textContent = JSON.stringify({ endDate: date });
  }

  function getConfig(wrap) {
    return {
      time: (wrap && wrap.getAttribute('data-cd-time')) || '11:59',
      period: ((wrap && wrap.getAttribute('data-cd-period')) || 'pm').toLowerCase(),
    };
  }

  function buildEndMs(endDate, wrap) {
    var m = String(endDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return NaN;

    var cfg = getConfig(wrap);
    var parts = cfg.time.split(':');
    var h = parseInt(parts[0], 10) || 11;
    var min = parseInt(parts[1], 10) || 59;

    if (cfg.period === 'pm' && h < 12) h += 12;
    if (cfg.period === 'am' && h === 12) h = 0;

    return new Date(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      h,
      min,
      59
    ).getTime();
  }

  function paint(el) {
    var wrap = el.closest(WRAP);
    if (!wrap) return;

    var endDate = getSettingDate(wrap);
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minEl = el.querySelector('[data-minutes]');

    el.style.display = '';

    if (!endDate) {
      if (daysEl) daysEl.textContent = '--';
      if (hoursEl) hoursEl.textContent = '--';
      if (minEl) minEl.textContent = '--';
      return;
    }

    var endMs = buildEndMs(endDate, wrap);
    if (isNaN(endMs)) {
      if (daysEl) daysEl.textContent = '--';
      if (hoursEl) hoursEl.textContent = '--';
      if (minEl) minEl.textContent = '--';
      return;
    }

    var diff = endMs - Date.now();
    el.classList.add('noju-countdown--ready');

    if (diff <= 0) {
      if (el.getAttribute('data-hide-on-complete') === 'true') {
        el.style.display = 'none';
      } else if (daysEl) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minEl.textContent = '00';
      }
      return;
    }

    if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400000));
    if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (minEl) minEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
  }

  function stop(el) {
    var t = timers.get(el);
    if (t) {
      clearInterval(t);
      timers.delete(el);
    }
  }

  function start(el) {
    if (!el || !el.matches(SELECTOR)) return;
    stop(el);
    paint(el);
    timers.set(
      el,
      setInterval(function () {
        if (!el.isConnected) {
          stop(el);
          return;
        }
        paint(el);
      }, 1000)
    );
  }

  function stopAll() {
    timers.forEach(function (t) {
      clearInterval(t);
    });
    timers.clear();
  }

  function dedupeWrap(wrap) {
    var syncs = wrap.querySelectorAll(SYNC);
    while (syncs.length > 1) {
      syncs[0].remove();
      syncs = wrap.querySelectorAll(SYNC);
    }
    var dataScripts = wrap.querySelectorAll(DATA);
    while (dataScripts.length > 1) {
      dataScripts[0].remove();
      dataScripts = wrap.querySelectorAll(DATA);
    }
    var nodes = wrap.querySelectorAll(SELECTOR);
    while (nodes.length > 1) {
      nodes[0].remove();
      nodes = wrap.querySelectorAll(SELECTOR);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(WRAP).forEach(function (wrap) {
      dedupeWrap(wrap);
      var date = getSettingDate(wrap);
      if (date) applyDateToWrap(wrap, date);
      wrap.querySelectorAll(SELECTOR).forEach(start);
    });
  }

  function scheduleRescan(root) {
    clearTimeout(observeTimer);
    observeTimer = setTimeout(function () {
      scan(root || document);
    }, 50);
  }

  function watchChanges() {
    if (!window.MutationObserver) return;

    var obs = new MutationObserver(function () {
      scheduleRescan(document);
    });

    function observe(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(WRAP).forEach(function (wrap) {
        obs.observe(wrap, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-countdown-setting-date'],
        });
      });
    }

    observe(document);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) observe(e.target);
      scheduleRescan(e.target || document);
    });
  }

  window.NojuCountdown = { restart: start, scan: scan };

  document.addEventListener('shopify:section:load', function (e) {
    stopAll();
    scheduleRescan(e.target || document);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target) e.target.querySelectorAll(SELECTOR).forEach(stop);
  });

  function boot() {
    scan(document);
    watchChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
